import { useEffect, useState } from "react";
import ReactSlider from "react-slider";

const Zoom = ({ mobileZoom }: any) => {
  const [zoomValue, setZoomValue] = useState(1);
  useEffect(() => {
    const editorArea: any = document.querySelector(".view-editor-area");
    if (editorArea) {
      editorArea.style.transform = `scale(${zoomValue})`;
    }
  }, [zoomValue]);

  return (
    <>
      {mobileZoom ? (
        <>
          {" "}
          <button
            onClick={() => {
              const newZoomValue = zoomValue + 0.1;
              if (zoomValue <= 10) setZoomValue(newZoomValue);
            }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="32"
                height="32"
                rx="16"
                fill="black"
                fillOpacity="0.32"
              />
              <g clipPath="url(#clip0_43877_32476)">
                <path
                  d="M24 23.2039L19.8607 19.0646L19.9403 18.9054C22.2487 16.0397 21.8507 11.8208 18.9054 9.43275C15.9602 7.04469 11.8209 7.6019 9.5124 10.4676C7.20394 13.3332 7.60195 17.6318 10.4676 19.9402C12.9353 21.9303 16.3582 21.9303 18.8258 20.0198L19.0646 19.8606L23.1243 23.9999L24 23.2039ZM14.6865 20.577C11.4228 20.577 8.87559 17.9502 8.87559 14.7661C8.87559 11.582 11.5025 8.95514 14.6865 8.95514C17.8706 8.95514 20.4975 11.582 20.4975 14.7661C20.4975 18.0298 17.8706 20.577 14.6865 20.577Z"
                  fill="white"
                />
                <path
                  d="M16.8358 14.3682H15.0846V12.6169H14.2886V14.3682H12.6169V15.1642H14.2886V16.8358H15.0846V15.1642H16.8358V14.3682Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_43877_32476">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
              </defs>
            </svg>
          </button>
          <button
            onClick={() => {
              const newZoomValue = zoomValue - 0.1;
              if (zoomValue >= 1) setZoomValue(newZoomValue);
            }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="32"
                height="32"
                rx="16"
                fill="black"
                fillOpacity="0.32"
              />
              <g clipPath="url(#clip0_43877_32476)">
                <path
                  d="M24 23.2039L19.8607 19.0646L19.9403 18.9054C22.2487 16.0397 21.8507 11.8208 18.9054 9.43275C15.9602 7.04469 11.8209 7.6019 9.5124 10.4676C7.20394 13.3332 7.60195 17.6318 10.4676 19.9402C12.9353 21.9303 16.3582 21.9303 18.8258 20.0198L19.0646 19.8606L23.1243 23.9999L24 23.2039ZM14.6865 20.577C11.4228 20.577 8.87559 17.9502 8.87559 14.7661C8.87559 11.582 11.5025 8.95514 14.6865 8.95514C17.8706 8.95514 20.4975 11.582 20.4975 14.7661C20.4975 18.0298 17.8706 20.577 14.6865 20.577Z"
                  fill="white"
                />
                <path d="M5.8 8h5.3v1H5.8z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_43877_32476">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(8 8)"
                  />
                </clipPath>
              </defs>
            </svg>
          </button>
        </>
      ) : (
        <>
          <ReactSlider
            className="range-slider"
            thumbClassName="range-slider-thumb"
            trackClassName="range-slider-track"
            min={1}
            max={10}
            step={0.1}
            value={zoomValue}
            onChange={(value) => {
              const editorArea = document.getElementById("editorArea");
              if (editorArea) {
                editorArea.style.transform = `scale(${value})`;
              }
              setZoomValue(value);
            }}
          />
          <span className="font-bold text-sm">{zoomValue}x</span>
        </>
      )}
    </>
  );
};

export default Zoom;
